import styled from 'styled-components';

export const Client = styled.div`
  background: white;
  min-height: 100%;
`
